import React from 'react';
import { Card } from '@/components/ui/card';
import BookingCard from '../BookingsManagement/BookingCard';

// Rich per-row detail identical to the Bookings page — reuses
// `<BookingCard hideCustomerRow openInBookings />` so staff sees
// status/source/payment method/payment audit/cancellation reason/
// cancelled-by/refund state without leaving the customer view. No action
// buttons here (Customer Management is read-only); each card gets an
// "Open" link that jumps to the operational view for that specific booking.
export default function BookingHistoryPanel({ bookings, locations, staffMap }) {
  return (
    <div className="lg:col-span-2">
      <h3 className="text-xl font-bold mb-4">Booking History</h3>
      {bookings.length === 0 ? (
        <Card className="p-6 text-center text-muted-foreground">
          No booking history
        </Card>
      ) : (
        <div className="space-y-3 max-h-[600px] overflow-y-auto pr-1" data-testid="customer-booking-history">
          {bookings.map(booking => {
            // Enrich with location_name so BookingCard's compact
            // (no-customer-row) branch can show the venue.
            // Cheap — locations map is already in memory.
            const enriched = {
              ...booking,
              location_name: locations[booking.location_id]?.name || booking.location_name,
            };
            return (
              <BookingCard
                key={booking.id}
                booking={enriched}
                staffMap={staffMap}
                hideCustomerRow
                openInBookings
              />
            );
          })}
        </div>
      )}
    </div>
  );
}
